import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ContentProvider } from "./context/ContentContext";
import { AppRoutes } from "./router";
import AdminPage from "./pages/admin/page";

function Dirs21Rebinder() {
  const location = useLocation();
  useEffect(() => {
    const timer = setTimeout(() => {
      if ((window as any).dirs21) {
        try {
          (window as any).dirs21.rebindTriggers();
        } catch (e) {}
      }
    }, 500);
    return () => {
      clearTimeout(timer);
      try {
        if ((window as any).dirs21) {
          (window as any).dirs21.unmountAll?.();
        }
      } catch (e) {}
    };
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ContentProvider>
        <BrowserRouter>
          <Dirs21Rebinder />
          <Routes>
            <Route path="*" element={<AppRoutes />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </I18nextProvider>
  );
}

export default App;